import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IssueTrackingComponent } from './issue-tracking.component';

@NgModule({
  declarations: [IssueTrackingComponent],
  imports: [CommonModule],
  exports: [IssueTrackingComponent],
})
export class IssueTrackingModule {}
